import { styled } from '@nx-kit/styling';

export const OptionsStyled = styled.div<{ isOpen: boolean }>`
  position: absolute;
  width: 200px;
  max-height: 200px;
  overflow-y: auto;
  top: calc(100% - 10px + 4px);
  left: 0;
  box-shadow: 0 10px 15px -5px rgba(11, 11, 11, 0.6);
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  background-color: ${(props) => props.theme.global.color.white};
`;

export const OptionStyled = styled.div`
  width: 100%;
  height: auto;
  background-color: ${(props) => props.theme.global.color.white};
  text-align: left;
  padding: 5px;
  cursor: pointer;
  margin: 5px 0;
  word-break: keep-all;

  &:hover {
    color: ${(props) => props.theme.global.color.primary};
    text-decoration: underline;
  }
`;
